import type { Token } from "./colour";

/** Coloured code, as runs of spans (from tokens.ts, made when the page is built). */
export function Tokens({ tokens }: { tokens: readonly Token[] }) {
  return tokens.map((t, i) => {
    const text = t.mark ? <mark className={t.mark}>{t.text}</mark> : t.text;
    return t.colour ? (
      <span key={i} className={`t-${t.colour}`}>
        {text}
      </span>
    ) : (
      <span key={i}>{text}</span>
    );
  });
}
